import { useTranslate, type TranslationKey } from 'shared/lib/i18n'

/**
 * A sidebar label read through the key-based i18n lookup, so no operator-facing
 * string is a literal in the rendered chrome.
 */
export function NavLabel({ label }: { label: TranslationKey }) {
	const { t } = useTranslate()
	return <>{t(label)}</>
}
